<template>
  <div class="text-2xl font-bold text-txprimary mb-14">Закрыть обращение?</div>
  <div class="flex justify-end gap-3 flex-row mt-6">
    <Button
      button-text="Закрыть"
      button-class="!px-0 !w-full !py-2"
      @click="$emit('confirm', ticketId)"
    />
    <ButtonLight button-text="Отмена" button-class="!px-0 !w-full" @click="$emit('cancel')" />
  </div>
</template>
<script setup lang="ts">
  import { Button, ButtonLight } from "@/components/UINew";

  defineProps<{
    ticketId: number;
    status: string;
  }>();

  defineEmits(["confirm", "cancel"]);
</script>
